export default "__VITE_ASSET__CNYMWTgF__"